import { render, staticRenderFns } from "./DigitalPoolsDetail.vue?vue&type=template&id=2911daab&scoped=true&"
import script from "./DigitalPoolsDetail.vue?vue&type=script&lang=js&"
export * from "./DigitalPoolsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DigitalPoolsDetail.vue?vue&type=style&index=0&id=2911daab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2911daab",
  null
  
)

export default component.exports